import { Broker } from "../objects/Broker";
import { brokerModel } from "../models/BrokerModel";
import { FirestoreDocument } from "@/core/modules/firestore/objects/FirestoreDocument";
import { SearchModule } from "@/core/modules/search/objects/SearchModule";
import { SortCriteria } from "@/core/modules/firestore/objects/SortCriteria";

export const brokerSearch: SearchModule = new SearchModule(
  "broker.broker",
  (firestoreDocument: FirestoreDocument) => Promise.resolve((firestoreDocument as Broker).name ?? "-"),
  (firestoreDocument: FirestoreDocument) => `/suppliers/${firestoreDocument.id}/edit`,
  "flag",
  brokerModel,
  [new SortCriteria("name", "asc", "string")]
);
